module.exports = __webpack_public_path__ + "static/media/medical-39_icon-icons.com_73906.f398f706.svg";